'use client';

import { useEffect } from 'react';

/**
 * Заголовок вкладки, выставленный после загрузки.
 *
 * Нужен страницам «не найдено»: сервер отдаёт верный `<title>` из их
 * `generateMetadata`, но на клиенте Next пересобирает метаданные этой
 * границы без неё — и во вкладке оказывался заголовок раздела с чужим
 * шаблоном: «AiSearch — INGDG» на aisearch.ru и datahunter.store
 * (находка 15.10.2026). Компонент возвращает вкладке тот же заголовок,
 * что видят поисковик и человек без JS.
 */
export function ZagolovokVkladki({ title }: { title: string }) {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}
